import { AssetType } from '@/api-gateway';
var tempProjectStore = {
    projectInfo: {
        name: '',
        region: '',
        latitude: null,
        longtitude: null,
        address: '',
        postcode: null,
        district: '',
        subdistrict: '',
        province: '',
        format: null,
        buildingFloor: '',
        subFormat: null,
        type: null,
        regionCode: null,
        projectCode: '',
        subFormatCode: null,
        owners: []
    },
    particularPack: {
        storeTypeAndStrategy: '',
        Location: '',
        zoning: '',
        retailRegulation: '',
        eia: false,
        remark: '',
        retailRegulationRemark: ''
    },
    particularPackFiles: [
        {
            type: AssetType.ParticularPackPdf,
            file: {}
        },
        {
            type: AssetType.ParticularPackVdo,
            file: {}
        }
    ],
    projectMembers: [],
    projectRelated: {
        programId: undefined,
        propertiesRelated: []
    }
};
var projectStore = JSON.parse(JSON.stringify(tempProjectStore));
export function clearStore() {
    projectStore.projectInfo = JSON.parse(JSON.stringify(tempProjectStore.projectInfo));
    projectStore.particularPack = JSON.parse(JSON.stringify(tempProjectStore.particularPack));
    projectStore.particularPackFiles = JSON.parse(JSON.stringify(tempProjectStore.particularPackFiles));
    projectStore.projectMembers = JSON.parse(JSON.stringify(tempProjectStore.projectMembers));
    projectStore.projectRelated = JSON.parse(JSON.stringify(tempProjectStore.projectRelated));
}
export default projectStore;
